import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import Button from './Button';
import heroBackground from '../images/Hero - AdobeStock_1162254814.png';

function Hero() {
  return (
    <section className="hero" style={{ backgroundImage: `url(${heroBackground})` }}>
      <div className="hero-overlay">
        <div className="hero-content">
          <h1 className="hero-title">Trade Show Planning, Simplified.</h1>
          <p className="hero-subtitle">Zibit helps teams streamline trade show planning—from budgeting to ROI reporting—all in one place.</p>
          <div className="hero-buttons">
            <Link to="/signup">
              <Button variant="primary">Get Started</Button>
            </Link>
            <Button variant="secondary">Watch Video</Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;